import React from "react";
import {
  DashboardHourlyBarChart,
  HourlyBarDatum,
} from "../DashboardHourlyBarChart";

interface InHouseChartProps {
  metricScale?: number;
  data?: HourlyBarDatum[];
}

export const InHouseChart: React.FC<InHouseChartProps> = ({
  metricScale = 0,
  data,
}) => {
  return (
    <DashboardHourlyBarChart
      primaryLabel="In-House reservations"
      secondaryLabel="Upsells"
      metricScale={metricScale}
      data={data}
    />
  );
};
